<template>
  <div class="main">
    <layout />
    <TopbgVue :title="title" />
    <div class="list">
      <div class="item-title">{{ title }}</div>
      <div class="rules">
        <div class="item">1. 新注册用户首次可以免费发布5条信息；超过的部分按2金币/条收取服务费；</div>
        <div class="item">2. 充值兑换：1元/10金币；</div>
        <div class="item">3. 置顶每次消耗2金币；大类置顶每次消耗4金币；</div>
        <div class="item">4. 用户在充值时一定核对好自己的账户和充值信息，一经充值，概不退款；</div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopbgVue from "./Topbg.vue";
import Footer from './footer.vue';
import Layout from './Layout.vue';
export default {
  data() {
    name:'Feerules'
    return {
      title: "收费规则",
    };
  },
  components: {
    TopbgVue,
    Layout,
    Footer
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.list {
  max-width: 1320px;
  margin: 80px auto 0;
  .item-title {
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #0099cc;
  }
  .rules {
    .item {
      padding-bottom: 20px;
      font-size: 16px;
      color: #717275;
    }
  }

}
</style>